import BulkPaymentLinkList from '../model/bulkPaymentLinkModel';
import {
    GET_RECENT_BULK_PAYMENT_LINK_FAILED,
    GET_RECENT_BULK_PAYMENT_LINK_SUCCESS,
    HIDE_BULK_PAYMENT_LOADER,
    SHOW_BULK_PAYMENT_LOADER,
    UPLOAD_BULK_PAYMENT_LINK_FAILED,
    UPLOAD_BULK_PAYMENT_LINK_SUCCESS,
} from './BulkPaymentLink.constants';

export const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    isLoading: false,
    uploadFile: {
        isSuccess: null,
        message: '',
        isLoading: '',
        data: {},
    },
};

export const bulkPaymentLinkReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RECENT_BULK_PAYMENT_LINK_SUCCESS:
            const bulkPaymentLinkTableData = new BulkPaymentLinkList(
                action.payload
            );
            return { ...state, ...bulkPaymentLinkTableData, error: {} };

        case GET_RECENT_BULK_PAYMENT_LINK_FAILED:
            return { ...state, ...action.payload };

        case UPLOAD_BULK_PAYMENT_LINK_SUCCESS: {
            return {
                ...state,
                error: {},
                uploadFile: {
                    isSuccess: true,
                    error: null,
                    data: { ...action.payload },
                },
            };
        }
        case UPLOAD_BULK_PAYMENT_LINK_FAILED:
            return {
                ...state,
                uploadFile: {
                    isSuccess: false,
                    error: { ...action.payload },
                    data: {},
                },
            };

        case SHOW_BULK_PAYMENT_LOADER:
            return { ...state, isLoading: true };
        case HIDE_BULK_PAYMENT_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
